import localforage from 'localforage';
import { ref } from 'vue';
import { defineStore } from 'pinia';

import { authService } from '../utils/api/authService';
import type { User } from '../utils/types';

export const useUserStore = defineStore(
  'user',
  () => {
    const user = ref<User | null>(null);

    async function getUserFromLocalforage() {
      await localforage.getItem<User>('user');
    }

    async function fetchUser() {
      await getUserFromLocalforage();

      if (user.value) return;

      user.value = await authService.getUser();
    }

    function invalidate() {
      user.value = null;

      fetchUser();
    }

    return {
      user,
      fetchUser,
      invalidate,
    };
  },
  {
    // @ts-ignore
    persist: true,
  }
);
